import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

type Params = { id: string | undefined };

export type PartWithChildrenDto = ClientInferResponseBody<
  typeof contract.parts.findOneWithChildren
>;

export const fetchPartWithChildren = async ({ id }: Params): Promise<PartWithChildrenDto> => {
  if (!id) {
    throw new Error("Part id is required");
  }

  const response = await api.parts.findOneWithChildren.query({
    params: { id },
  });
  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError(
    `Failed to fetch part with children: status ${response.status}`,
    response.status,
    response.body,
  );
};
